import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

export const GroupCreateModalLoader = () =>
  import(/* webpackChunkName: "4-feat-group-create" */ './GroupCreateModalFlighted');

export default lazyLoadOnRender({ loader: GroupCreateModalLoader });
